import { RootSelector, getStore } from '../../reducers';
import { RouterShape, Page } from './model';
import { createSelector } from '@reduxjs/toolkit';

export const getRouter: RootSelector<RouterShape> = createSelector(
  getStore,
  (state) => state.router,
);

export const getPage: RootSelector<Page | null> = createSelector(
  getRouter,
  (router) => router.page,
);
